import React, { useEffect } from "react";
import { AlertLineReportDTO } from "../../../../../models/alert-line-report/alert-line-report-dto";
import PreviousAlertLineReportDetails from "./PreviousAlertLineReportDetails";
import PreviousAlerLineReportNotes from "./PreviousAlertLineReportNotes";
import { Container } from "./styles";
import { Chip, Divider, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AvailableLanguageRef } from "../../../../../models/available-language";

interface Props {
  alertLineReport: AlertLineReportDTO;
  handleSetLanguage: (language: AvailableLanguageRef) => void;
}
const PreviousAlertLineReportContent = ({ alertLineReport, handleSetLanguage }: Props) => {
  const tRP = "components.previous_report";
  const { t, i18n } = useTranslation();
  const theme = useTheme();

  useEffect(() => {
    if (alertLineReport.language && alertLineReport.language.code !== i18n.language) {
      handleSetLanguage(alertLineReport.language);
    }
  }, [alertLineReport]);

  return (
    <Container>
      <PreviousAlertLineReportDetails alertLineReport={alertLineReport} />
      <Divider
        orientation="horizontal"
        style={{ alignItems: "flex-start" }}
      >
        <Chip
          label={`${t(`${tRP}.notes`)}`}
          style={{ color: theme.palette.secondary.light }}
        />
      </Divider>
      <PreviousAlerLineReportNotes alertLineReport={alertLineReport} />
    </Container>
  );
};
export default PreviousAlertLineReportContent;
